export const fetchEpisodesSuccess = (payload) => ({type: 'FETCH_EPISODES_SUCCESS', payload });
